import { removeAccents } from "./removeAccents";

export const filterAddresses = (addresses, txt) => {
  txt = txt.trim();
  if (txt === "") {
    return [];
  } else {
    txt = removeAccents(txt).toLowerCase();
    let tempAddr = addresses.filter((o) => {
      if (o.NOM !== "") {
        let name = removeAccents(o.NOM).toLowerCase();

        if (txt.includes(" ")) {
          let parts = txt.split(" ");
          return (
            parts.filter((b) => {
              return name.includes(b.toLowerCase());
            }).length === parts.length
          );
        } else {
          return name.includes(txt);
        }
      }
      return false;
    });
    tempAddr.length > 200 && (tempAddr.length = 200);
    return tempAddr;
  }
};
